import * as React from "react";
function SvgArrowLeft(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.293 4.3l-7 7a1 1 0 000 1.414l7 7 1.414-1.414-5.293-5.293H21v-2H6.414l5.293-5.293L10.293 4.3z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgArrowLeft);
export default ForwardRef;
